module.exports = __webpack_public_path__ + "img/stuDetailIcon1@2x.9d07ce6f.png";